/// <amd-module name="Core/Medius.Core.Web/Scripts/components/readonlyTabs/services"/>
import {get} from "Core/Medius.Core.Web/Scripts/Medius/core/fetch/rest";
import { IDocumentImportInformation } from "./interfaces";

export function getInformation(documentId: string):Promise<IDocumentImportInformation> {
    return get(`remedium-api/apa/DocumentImport/${documentId}/information`);
}
